import { render, staticRenderFns } from "./digRtwo.vue?vue&type=template&id=8961fbe8&scoped=true"
import script from "./digRtwo.vue?vue&type=script&lang=js"
export * from "./digRtwo.vue?vue&type=script&lang=js"
import style0 from "./digRtwo.vue?vue&type=style&index=0&id=8961fbe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8961fbe8",
  null
  
)

export default component.exports